import { render, staticRenderFns } from "./NominationPreview.vue?vue&type=template&id=f053bff4"
import script from "./NominationPreview.vue?vue&type=script&lang=js"
export * from "./NominationPreview.vue?vue&type=script&lang=js"
import style0 from "./NominationPreview.vue?vue&type=style&index=0&id=f053bff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports